/**
 * Generated by orval 🍺
 * Do not edit manually.
 * PASS API
 * OpenAPI spec version: 3.0.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";

import { nmibleInstanceV3 } from "../../mutator/axios-instance-v3";

import type {
  ErrorResponse,
  HTTPValidationError,
  SupportMessageRead,
  SupportMessageUpdate,
} from "../../model";
import type { ErrorType, BodyType } from "../../mutator/axios-instance-v3";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * Sets or replaces the tenant's custom support message (rich text). The HTML body is sanitized server-side to a safe formatting subset before storage. Super-admin only.
 * @summary Set the custom support message for a tenant
 */
export const setSupportMessageEndpointTenantsTenantNameSupportMessagePut = (
  tenantName: string,
  supportMessageUpdate: BodyType<SupportMessageUpdate>,
  options?: SecondParameter<typeof nmibleInstanceV3>,
  signal?: AbortSignal
) => {
  return nmibleInstanceV3<SupportMessageRead>(
    {
      url: `/tenants/${tenantName}/support/message`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: supportMessageUpdate,
      signal,
    },
    options
  );
};

export const getSetSupportMessageEndpointTenantsTenantNameSupportMessagePutMutationKey =
  () =>
    ["setSupportMessageEndpointTenantsTenantNameSupportMessagePut"] as const;

export const getSetSupportMessageEndpointTenantsTenantNameSupportMessagePutMutationOptions =
  <
    TError = ErrorType<ErrorResponse | HTTPValidationError>,
    TContext = unknown,
  >(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof setSupportMessageEndpointTenantsTenantNameSupportMessagePut
        >
      >,
      TError,
      SetSupportMessageEndpointTenantsTenantNameSupportMessagePutMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof setSupportMessageEndpointTenantsTenantNameSupportMessagePut
      >
    >,
    TError,
    SetSupportMessageEndpointTenantsTenantNameSupportMessagePutMutationVariables,
    TContext
  > => {
    const mutationKey =
      getSetSupportMessageEndpointTenantsTenantNameSupportMessagePutMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof setSupportMessageEndpointTenantsTenantNameSupportMessagePut
        >
      >,
      SetSupportMessageEndpointTenantsTenantNameSupportMessagePutMutationVariables
    > = (props) => {
      const { tenantName, data } = props ?? {};

      return setSupportMessageEndpointTenantsTenantNameSupportMessagePut(
        tenantName,
        data,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type SetSupportMessageEndpointTenantsTenantNameSupportMessagePutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof setSupportMessageEndpointTenantsTenantNameSupportMessagePut
      >
    >
  >;
export type SetSupportMessageEndpointTenantsTenantNameSupportMessagePutMutationBody =
  BodyType<SupportMessageUpdate>;
export type SetSupportMessageEndpointTenantsTenantNameSupportMessagePutMutationError =
  ErrorType<ErrorResponse | HTTPValidationError>;
export interface SetSupportMessageEndpointTenantsTenantNameSupportMessagePutMutationVariables {
  tenantName: string;
  data: BodyType<SupportMessageUpdate>;
}

/**
 * @summary Set the custom support message for a tenant
 */
export const useSetSupportMessageEndpointTenantsTenantNameSupportMessagePut = <
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof setSupportMessageEndpointTenantsTenantNameSupportMessagePut
        >
      >,
      TError,
      SetSupportMessageEndpointTenantsTenantNameSupportMessagePutMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof setSupportMessageEndpointTenantsTenantNameSupportMessagePut
    >
  >,
  TError,
  SetSupportMessageEndpointTenantsTenantNameSupportMessagePutMutationVariables,
  TContext
> => {
  return useMutation(
    getSetSupportMessageEndpointTenantsTenantNameSupportMessagePutMutationOptions(
      options
    ),
    queryClient
  );
};
/**
 * Clears the tenant's custom support message. Idempotent -- returns 204 whether or not a message was configured. Super-admin only.
 * @summary Delete the custom support message for a tenant
 */
export const deleteSupportMessageEndpointTenantsTenantNameSupportMessageDelete =
  (
    tenantName: string,
    options?: SecondParameter<typeof nmibleInstanceV3>,
    signal?: AbortSignal
  ) => {
    return nmibleInstanceV3<void>(
      {
        url: `/tenants/${tenantName}/support/message`,
        method: "DELETE",
        signal,
      },
      options
    );
  };

export const getDeleteSupportMessageEndpointTenantsTenantNameSupportMessageDeleteMutationKey =
  () =>
    [
      "deleteSupportMessageEndpointTenantsTenantNameSupportMessageDelete",
    ] as const;

export const getDeleteSupportMessageEndpointTenantsTenantNameSupportMessageDeleteMutationOptions =
  <TError = ErrorType<HTTPValidationError>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteSupportMessageEndpointTenantsTenantNameSupportMessageDelete
        >
      >,
      TError,
      DeleteSupportMessageEndpointTenantsTenantNameSupportMessageDeleteMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteSupportMessageEndpointTenantsTenantNameSupportMessageDelete
      >
    >,
    TError,
    DeleteSupportMessageEndpointTenantsTenantNameSupportMessageDeleteMutationVariables,
    TContext
  > => {
    const mutationKey =
      getDeleteSupportMessageEndpointTenantsTenantNameSupportMessageDeleteMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteSupportMessageEndpointTenantsTenantNameSupportMessageDelete
        >
      >,
      DeleteSupportMessageEndpointTenantsTenantNameSupportMessageDeleteMutationVariables
    > = (props) => {
      const { tenantName } = props ?? {};

      return deleteSupportMessageEndpointTenantsTenantNameSupportMessageDelete(
        tenantName,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteSupportMessageEndpointTenantsTenantNameSupportMessageDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteSupportMessageEndpointTenantsTenantNameSupportMessageDelete
      >
    >
  >;

export type DeleteSupportMessageEndpointTenantsTenantNameSupportMessageDeleteMutationError =
  ErrorType<HTTPValidationError>;
export interface DeleteSupportMessageEndpointTenantsTenantNameSupportMessageDeleteMutationVariables {
  tenantName: string;
}

/**
 * @summary Delete the custom support message for a tenant
 */
export const useDeleteSupportMessageEndpointTenantsTenantNameSupportMessageDelete =
  <TError = ErrorType<HTTPValidationError>, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof deleteSupportMessageEndpointTenantsTenantNameSupportMessageDelete
          >
        >,
        TError,
        DeleteSupportMessageEndpointTenantsTenantNameSupportMessageDeleteMutationVariables,
        TContext
      >;
      request?: SecondParameter<typeof nmibleInstanceV3>;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof deleteSupportMessageEndpointTenantsTenantNameSupportMessageDelete
      >
    >,
    TError,
    DeleteSupportMessageEndpointTenantsTenantNameSupportMessageDeleteMutationVariables,
    TContext
  > => {
    return useMutation(
      getDeleteSupportMessageEndpointTenantsTenantNameSupportMessageDeleteMutationOptions(
        options
      ),
      queryClient
    );
  };
/**
 * Returns the custom support message (sanitized rich-text HTML) for the tenant resolved from the request domain. Public -- read by the participants app support page. Always 200: ``message_html`` is null when the tenant has not configured a message.
 * @summary Get the custom support message for the current tenant
 */
export const getSupportMessageForCurrentTenantSupportMessageGet = (
  options?: SecondParameter<typeof nmibleInstanceV3>,
  signal?: AbortSignal
) => {
  return nmibleInstanceV3<SupportMessageRead>(
    { url: `/support/message`, method: "GET", signal },
    options
  );
};

export const getGetSupportMessageForCurrentTenantSupportMessageGetQueryKey =
  () => {
    return [`/support/message`] as const;
  };

export const getGetSupportMessageForCurrentTenantSupportMessageGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getSupportMessageForCurrentTenantSupportMessageGet>
    >,
    TError = ErrorType<unknown>,
  >(options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getSupportMessageForCurrentTenantSupportMessageGet>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  }) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetSupportMessageForCurrentTenantSupportMessageGetQueryKey();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getSupportMessageForCurrentTenantSupportMessageGet>
      >
    > = ({ signal }) =>
      getSupportMessageForCurrentTenantSupportMessageGet(
        requestOptions,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof getSupportMessageForCurrentTenantSupportMessageGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type GetSupportMessageForCurrentTenantSupportMessageGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getSupportMessageForCurrentTenantSupportMessageGet>
    >
  >;
export type GetSupportMessageForCurrentTenantSupportMessageGetQueryError =
  ErrorType<unknown>;

export function useGetSupportMessageForCurrentTenantSupportMessageGet<
  TData = Awaited<
    ReturnType<typeof getSupportMessageForCurrentTenantSupportMessageGet>
  >,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getSupportMessageForCurrentTenantSupportMessageGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getSupportMessageForCurrentTenantSupportMessageGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getSupportMessageForCurrentTenantSupportMessageGet
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSupportMessageForCurrentTenantSupportMessageGet<
  TData = Awaited<
    ReturnType<typeof getSupportMessageForCurrentTenantSupportMessageGet>
  >,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getSupportMessageForCurrentTenantSupportMessageGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getSupportMessageForCurrentTenantSupportMessageGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getSupportMessageForCurrentTenantSupportMessageGet
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSupportMessageForCurrentTenantSupportMessageGet<
  TData = Awaited<
    ReturnType<typeof getSupportMessageForCurrentTenantSupportMessageGet>
  >,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getSupportMessageForCurrentTenantSupportMessageGet>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get the custom support message for the current tenant
 */

export function useGetSupportMessageForCurrentTenantSupportMessageGet<
  TData = Awaited<
    ReturnType<typeof getSupportMessageForCurrentTenantSupportMessageGet>
  >,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getSupportMessageForCurrentTenantSupportMessageGet>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetSupportMessageForCurrentTenantSupportMessageGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}
